const startTime = 9
const endTime = 21

const getTimeIntervals = function (start, end) {
  const result = []
  for (let i = start; i < end; i++) {
    const hour = i.toString().length > 1 ? i : `0${i}`
    result.push({
      value: `${hour}:00`,
      name: `${hour}:00`
    })
    result.push({
      value: `${hour}:30`,
      name: `${hour}:30`
    })
  }
  return result
}

export default {
  name: 'timepicker',
  props: ['value'],
  data: function () {
    return {
      timeIntervals: getTimeIntervals(startTime, endTime),
      selectedTime: null
    }
  },
  watch: {
    selectedTime: function () {
      this.$emit('input', this.selectedTime)
    },
    value: function () {
      if (this.value) {
        this.selectedTime = this.value
      }
    }
  },
  created: function () {
    this.selectedTime = this.value || this.timeIntervals[0].value
  }
}
